'use es6';

import { Map as ImmutableMap } from 'immutable';
import Actions from 'AdsUI/lib/Actions';
import { TrackerTypeToRecord } from 'AdsUI/records/rmf/AdWordsConversionTrackerEntityRecords';
export default ((state = ImmutableMap(), action) => {
  const {
    type,
    payload = []
  } = action;

  switch (type) {
    case Actions.ADWORDS_SET_UI_CONVERSION_TRACKER:
      state = payload;
      break;

    case Actions.ADWORDS_UPDATE_UI_CONVERSION_TRACKER:
      state = state.merge(payload);
      break;

    case Actions.ADWORDS_CONVERSION_TRACKERS_SAVE_SUCCEEDED:
      if (payload.trackerType) {
        state = new TrackerTypeToRecord[payload.trackerType](payload);
      }

      break;

    case Actions.ADWORDS_CONVERSION_TRACKERS_SYNC_SUCCEEDED:
      if (payload.trackerType) {
        state = new TrackerTypeToRecord[payload.newTracker.trackerType](payload.newTracker);
      }

      break;

    default:
      break;
  }

  return state;
});